import React from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'
import { PageCrumbs } from 'components'

const StyledAccountsDomainsTop = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 192px',
  marginBottom: 20
})

const AccountsDomainsTop = ({ accountName, onNewDomain }) => {
  return (
    <StyledAccountsDomainsTop>
      <PageCrumbs
        crumbs={[
          { name: 'Administration', icon: 'bars', path: '/administration/account' },
          { name: accountName },
          { name: 'Domains' }
        ]}
      />
      <Button type="primary" icon="plus" onClick={onNewDomain}>
        ADD NEW DOMAIN
      </Button>
    </StyledAccountsDomainsTop>
  )
}

export default AccountsDomainsTop
